<div class="closing-x-wrap">
    <img (click)="closeModal()" class="close-icon" src="../../../assets/img/closing-x.svg" alt="close modal" />
</div>

<div mat-dialog-content class="doc-container">
    <div *ngIf="pdfUrl">
        <div class="buttons">
            <div *ngIf="isDownloadButtonVisible()">
                <a *ngIf="!isLoading" href="{{ pdfUrl }}" target="_blank" download="ddjDocument.pdf">
                    <button mat-raised-button class="button primary-btn">Download</button></a
                >
            </div>
            <div *ngIf="isPrintButtonVisible()">
                <button *ngIf="!isLoading" mat-raised-button class="button primary-btn print-button" (click)="printPdf()">Print</button>
            </div>
        </div>

        <pdf-viewer
            [src]="pdfUrl"
            [render-text]="false"
            [original-size]="false"
            [autoresize]="true"
            (after-load-complete)="onPdfLoadComplete($event)"
            (error)="onError($event)"
            style="{{ pdfStyle() }}"
        ></pdf-viewer>
    </div>
</div>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
